// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"G1-z"};